import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class SignalAugmentationPositionView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      columns: [],
      groups: [],

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const tempColumns = [
      columns[0],
      "ibau_request",
      "a_biu_request",
      "a_bgiu_request",
    ];

    const arrangeCol = [
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "ibau_request",
        label: "a/b/i/u",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "a_biu_request",
        label: "a-/b#/i#/u#",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "a_biu_abiu_ratio",
        label: "ratio-1",
        parsefunc: ({ ibau_request, a_biu_request }) => {
          return ibau_request === 0 ||
            a_biu_request === "-" ||
            ibau_request === "-"
            ? 0
            : a_biu_request / ibau_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "a_bgiu_request",
        label: "a-/bg#/i#/u#",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "a_bgiu_abiu_ratio",
        label: "ratio-2",
        parsefunc: ({ ibau_request, a_bgiu_request }) => {
          return ibau_request === 0 ||
            a_bgiu_request === "-" ||
            ibau_request === "-"
            ? 0
            : a_bgiu_request / ibau_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const dateIdx = _.indexOf(columns, "date");
    const kvalIdx = _.indexOf(columns, "key_value");
    const reqIdx = _.indexOf(columns, "request_v2");

    const newRecords = [];

    _.forEach(records, (item) => {
      const date = item[dateIdx];
      const kval = item[kvalIdx];
      const req = item[reqIdx];

      let index = _.findIndex(newRecords, (record) => {
        return record[0] === date;
      });

      if (index < 0) {
        newRecords.push([date, 0, 0, 0]);
        index = newRecords.length - 1;
      }

      if (/^(i|b|a|u\d)$/.test(kval)) {
        newRecords[index][1] += req;
      }
      if (/^(a-\d|b\d|i\d|u\d)$/.test(kval)) {
        newRecords[index][2] += req;
      }
      if (/^(a-\d|bg\d|i\d|u\d)$/.test(kval)) {
        newRecords[index][3] += req;
      }
    });

    const result = parseTableData({
      columns: tempColumns,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "date",
    });

    this.setState({
      ...result,
      columns: arrangeCol,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      tags: arrangeCol.slice(1).map((item) => ({
        value: item.key,
        label: item.label,
        group: item.group,
      })),
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { filterAmount, filterGroups, filterRecords, columns, tags } =
      this.state;

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <GroupDataTable
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="date"
          columns={columns}
        ></GroupDataTable>
      </>
    );
  }
}

export default SignalAugmentationPositionView;
